import { getCookie } from '../utility/Utils';

export const getAccessToken = () => {
  let accessToken;
  if (
    (window.location.pathname.includes('/member') ||
      window.location.pathname.includes('/admin')) &&
    localStorage.getItem('isCompanyAdmin') &&
    localStorage.getItem('memberUserId') &&
    localStorage.getItem('memberToken')
  ) {
    const currentTabUser = localStorage.getItem('currentActiveTabUser');
    const memberUserId = localStorage.getItem('memberUserId');
    if (
      currentTabUser &&
      memberUserId &&
      atob(currentTabUser) === atob(memberUserId)
    ) {
      return localStorage.getItem('memberToken');
    }
    return getCookie('token');
  } else if (
    window.location.pathname.includes('/admin') &&
    localStorage.getItem('isSuperAdmin') &&
    localStorage.getItem('adminUserId') &&
    localStorage.getItem('adminToken')
  ) {
    accessToken = localStorage.getItem('adminToken');
  } else {
    accessToken = getCookie('token');
  }
  return accessToken;
};
